import API_GATEWAY from "@/services/config/main-axios";

const transactionsService = {
  getDepositTransactions(filters) {
    return API_GATEWAY.get("reporter/admin/transaction/deposit", {
      params: filters
    });
  },

  getDepositTrxById(id) {
    return API_GATEWAY.get(`reporter/admin/transaction/deposit/${id}`);
  },

  checkTrxStatusById(id) {
    return API_GATEWAY.post("admin/order/retry-transaction", id);
  },

  getWithdrawalTransactions(filters) {
    return API_GATEWAY.get("reporter/admin/transaction/withdraw", {
      params: filters
    });
  },

  getWithdrawTrxById(id) {
    return API_GATEWAY.get(`reporter/admin/transaction/withdraw/${id}`);
  },

  getRefundTransactions(filters) {
    return API_GATEWAY.get("reporter/admin/transaction/refund", {
      params: filters
    });
  },

  getRefundTrxById(id) {
    return API_GATEWAY.get(`reporter/admin/transaction/refund/${id}`);
  },

  getTransactionsStatuses() {
    return API_GATEWAY.get("user-profile/admin/getAllTransactionStatus");
  },

  getTransactionsWithdrawalStatuses() {
    return API_GATEWAY.get("user-profile/admin/getAllWithdrawStatus");
  },

  getTransactionsRefundStatuses() {
    return API_GATEWAY.get("user-profile/admin/getAllRefundStatus");
  }
};

export default transactionsService;
